// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import uuidv4 from 'uuid/v4';
import { connect } from 'react-redux';
import parse from 'html-react-parser';

import { getData } from '../store/selectors';
import * as howItWorksActions from '../store/actions';
import * as globalActions from '../../../store/globalStore/actions';
import Navigation from '../../../common/Navigation/Navigation';
import { Helper } from '../components';
import { DownloadIcon } from '../../home/components';
import styles from './styles';

class HowitworksPage extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    setPage: PropTypes.func,
    requestPageData: PropTypes.func,
    data: PropTypes.object,
  };

  static defaultProps = {
    classes: {},
    setPage: () => { },
    requestPageData: () => { },
    data: {
      imagesWithDescription: [],
    },
  };

  componentDidMount() {
    this.props.setPage({ current_page: 'How it works' });
    this.props.requestPageData();
  }

  componentWillUnmount() {
    this.props.setPage({ current_page: null });
  }

  render() {
    const { classes, data } = this.props;

    return (
      <Navigation isHiw mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <span className={classes.title}>HOW IT WORKS</span>
          <div className={classes.helpersContainer}>
            {data.imagesWithDescription.map((el, i) => (
              <Helper key={uuidv4()} {...el} reverse={i % 2 === 0} />
            ))}
          </div>
          <div className={classes.bottomInfoContainer}>
            <div className={classes.textContainer}>
              <span className={classNames(classes.text, classes.marginBottom)}>
                {parse(data.description_paragraph1)}
              </span>
              <span className={classNames(classes.text, classes.marginLeft)}>
                {parse(data.description_paragraph2)}
              </span>
            </div>
            <div className={classes.downloadIconContainer}>
              <DownloadIcon />
            </div>
          </div>
        </div>
      </Navigation>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: getData(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: page => dispatch(globalActions.setPage(page)),
    requestPageData: () => dispatch(howItWorksActions.requestPageData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HowitworksPage));
